import Vue from 'vue'
import './axios'
import App from './App.vue'
import router from './router'
import NProgress from 'nprogress'
import store from './store'
import './plugins/vant.js'
// import 'lib-flexible'
import './plugins/rem'
import * as filters from './filters/index' // global filters
import { isQYWeixin, isWeixin } from './utils/weixin'
import { Notify, Cascader } from 'vant'
import './styles/index.scss'
import '@/plugins/swiper'
import Clipboard from 'clipboard'
import './directives'
import './plugins/vue-photo-preview'

// 引入echarts
import echarts from 'echarts'
import { E_CHARTS } from './views/VA'
Vue.prototype.$echarts = echarts
Vue.prototype.Clipboard = Clipboard

Vue.use(Cascader)

NProgress.configure({ showSpinner: false })
Vue.prototype.$bus = new Vue()

if (process.env.VUE_APP_ENV === 'staging') {
  import('@/plugins/vconsole')
}

Object.keys(filters).forEach(key => {
  Vue.filter(key, filters[key])
})

Vue.config.productionTip = false

const init = async function() {
  // ['production', 'release'].includes(process.env.VUE_APP_ENV) && await import('@/plugins/Sentry')
  try {
    if (isQYWeixin()) {
      await require('https://res.wx.qq.com/open/js/jweixin-1.2.0.js')
    } else {
      await require('https://res.wx.qq.com/open/js/jweixin-1.6.0.js')
    }
  } catch (error) {
    console.error(error)
  }

  // const { current } = router.history

  return new Vue({
    router,
    store,
    provide: {
      [E_CHARTS]: echarts
    },
    render: h => h(App)
  }).$mount('#app')
}

router.beforeEach((to, from, next) => {
  /* 路由发生变化修改页面title */
  if (to.meta.title) {
    document.title = to.meta.title
  }
  if (!isWeixin() && (to.path !== '/driver/list' || '/driver/LessHome')) {
    Notify({ type: 'danger', message: '请使用微信打开页面' })
    return
  }
  next()
})

const VueInstance = init()

export default VueInstance
